module.exports = __webpack_public_path__ + "components/country-flag/static/gd-9357b33dc4ff2614d2dd34386eff33ad.svg";